import { render, staticRenderFns } from "./account-dropdown.vue?vue&type=template&id=68311469&scoped=true&"
import script from "./account-dropdown.vue?vue&type=script&lang=js&"
export * from "./account-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./account-dropdown.vue?vue&type=style&index=0&id=68311469&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68311469",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68311469')) {
      api.createRecord('68311469', component.options)
    } else {
      api.reload('68311469', component.options)
    }
    module.hot.accept("./account-dropdown.vue?vue&type=template&id=68311469&scoped=true&", function () {
      api.rerender('68311469', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/user-menu/account-dropdown.vue"
export default component.exports